module.exports = __webpack_public_path__ + "img/sv74.01664c5c.svg";